(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ta-premium-home"] && !Shopify.designMode) return;
  try {
    
  // Give the visible poster first use of the connection; enhance it with motion
  // only after it has decoded and the browser has had a chance to paint it.
  function initializeTaHero(root) {
    root.querySelectorAll('[data-ta-hero-video]').forEach((video) => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotion.matches || navigator.connection?.saveData) return;
      const poster = video.parentElement.querySelector('[data-ta-hero-poster]');
      const start = () => {
        if (!video.isConnected || reducedMotion.matches) return;
        video.muted = true;
        video.src = video.dataset.videoSrc;
        video.addEventListener('playing', () => { video.dataset.playing = 'true'; }, { once: true });
        video.play().catch(() => { /* The poster remains visible if autoplay is blocked. */ });
      };
      const schedule = () => requestAnimationFrame(() => requestAnimationFrame(() => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1500 });
        else setTimeout(start, 200);
      }));
      if (poster?.decode) poster.decode().then(schedule).catch(schedule);
      else if (poster && !poster.complete) poster.addEventListener('load', schedule, { once: true });
      else schedule();
      reducedMotion.addEventListener('change', (event) => {
        if (event.matches) { video.pause(); delete video.dataset.playing; }
      });
    });
  }
  initializeTaHero(document);
  document.addEventListener('shopify:section:load', (event) => initializeTaHero(event.target));

  } catch(e) { console.error(e); }
})();
})();
